import { DiasDisponibles } from "src/gql/schema"

export const days = [
    DiasDisponibles.Domingo,
    DiasDisponibles.Lunes,
    DiasDisponibles.Martes,
    DiasDisponibles.Miercoles,
    DiasDisponibles.Jueves,
    DiasDisponibles.Viernes,
    DiasDisponibles.Sabado,
]

export interface Medidas {
    width: number
    height: number
}

// Ancho de `.disp__card-section` en las pantallas para las que está diseñado el CSS de las tarjetas.
const ANCHO_BASE_VERTICAL = 1032 // pantalla vertical de 1080px
const ANCHO_BASE_HORIZONTAL = 862 // pantalla horizontal de 1280px
const ESPACIO_PAGINADOR = 40
const SEPARACION_CARDS = 20 // row-gap de `.disp__card-list`
const ALTO_TITULO_LISTA = 93 // `.disp__card-list-title`, solo visible en horizontal

const esVertical = (viewport: Medidas) => viewport.height >= viewport.width

// Alto de cada tarjeta según el CSS del breakpoint activo (incluye sus márgenes).
const getAltoCard = (viewport: Medidas, isListaEspera: boolean) => {
    if (isListaEspera) return esVertical(viewport) ? 238 + 20 : 120
    if (esVertical(viewport)) return 240 + 30
    return viewport.width <= 1280 ? 160 : 240
}

// Si el contenedor es más angosto que el diseño, las tarjetas se renderizan al ancho de diseño y se escalan
// completas, para que conserven su acomodo. Nunca se agrandan.
export const getEscalaCards = (area: Medidas, viewport: Medidas) => {
    if (!area.width) return 1
    const anchoBase = esVertical(viewport) ? ANCHO_BASE_VERTICAL : ANCHO_BASE_HORIZONTAL
    return Math.min(1, area.width / anchoBase)
}

export const getCardsPorPagina = (area: Medidas, viewport: Medidas, isListaEspera = false) => {
    const escala = getEscalaCards(area, viewport)
    const altoTitulo = isListaEspera && !esVertical(viewport) ? ALTO_TITULO_LISTA + SEPARACION_CARDS : 0
    // Alto disponible en pixeles sin escalar, que es en lo que miden las tarjetas.
    const alto = (area.height - ESPACIO_PAGINADOR) / escala - altoTitulo
    const cards = Math.floor((alto + SEPARACION_CARDS) / (getAltoCard(viewport, isListaEspera) + SEPARACION_CARDS))

    // Siempre al menos una por página: con 0 el for de `getItems` nunca avanzaría.
    return Math.max(1, cards)
}

export const getItems = <T>(data: T[], porPagina: number): T[][] => {
    const list: T[][] = []

    for (let i = 0; i < data.length; i += porPagina) {
        list.push(data.slice(i, i + porPagina))
    }

    return list
}

export const getCapitalizeText = (text: string) => {
    let value = ""
    text?.split(" ")?.forEach((v) => {
        const item = v?.charAt(0)?.toUpperCase() + v?.slice(1)?.toLowerCase()
        value = `${value}${value.length > 0 ? " " : ""}${item}`
    })

    return value
}

export function getCamaLabel(value: string) {
    let label = ""
    value.split("_").forEach((text, index) => {
        label += `${index !== 0 ? " " : ""}${text.charAt(0).toUpperCase() + text.slice(1)}`
    })

    return label
}

export function getOrderUrls(urls: string[]) {
    const getIndex = (url: string) => {
        const match = url.match(/_(\d+)\.[^.]+$/)

        return match ? Number(match[1]) : Infinity
    }

    return [...urls].sort((a, b) => getIndex(a) - getIndex(b))
}

export const getLabelCamas = (camas: any[]) => {
    let label = ""
    camas.forEach((i, index)=>{
        const cama = `${i?.numero || 1} ${i?.tipo ? getCamaLabel(i?.tipo) : "Cama"}`
        label = label + cama  + (index !== camas.length - 1 ? ", " : "")
    })
    return label
}

export function getWords(text: string, max = 2) {
    return text.trim().split(/\s+/).slice(0, max).join(" ");
}

export const getHoras = (configuration_noche: any) => {
    const toSeconds = (time: string) => {
        const [h, m, s] = time.split(":").map(Number);
        return h * 3600 + m * 60 + s;
    };

    const start = toSeconds(configuration_noche?.hora_checkin || "00:00:00");
    let end = toSeconds(configuration_noche?.hora_checkout || "00:00:00");

    if (end < start) {
        end += 24 * 3600;
    }

    return Math.round((end - start) / 3600)
}